@if (hasHeader) {
    <h-shop-info-header
        [shop]="shop"
        [linkMode]="linkMode"
        [headerLevelShopTitle]="headerLevelShopTitle"
        (shopInfoHeaderEvents)="shopInfoEvents.emit($event)">
    </h-shop-info-header>
}
@if (hasSeparator) {
    <h-separator [lightColor]="false"></h-separator>
}

<h-shop-info-details
    [shop]="shop"
    [headerLevelShopTitle]="headerLevelShopTitle"
    [directionLinkMode]="directionLinkMode"
    [directionUrl]="directionUrl"
    [meters]="meters"
    [sectionsToDisplay]="sectionsToDisplay"
    (shopInfoDetailsEvents)="shopInfoEvents.emit($event)"
    (shopInfoDirectionEvents)="shopInfoEvents.emit($event)">
</h-shop-info-details>
